<!-- Aviso flotante de nuevos mensajes de soporte -->
<div *ngIf="showNewMessageToast && (!isOpen || isMinimized)" class="chat-new-msg-toast" role="status" aria-live="polite">
    <div class="toast-content">
        <div class="toast-icon" aria-hidden="true">
            <img [src]="config.iconSrc" alt="Chat soporte"/>
        </div>
        <div class="toast-text">{{ config.toastText }}</div>
        <button type="button" class="toast-action" (click)="onToastOpenClick($event)" style="background: transparent;">Ver</button>
        <button type="button" class="toast-close" (click)="hideNewMessageToast($event)" aria-label="Cerrar">✕</button>
    </div>
    <span class="sr-only">Notificación de nuevos mensajes de soporte simyo</span>
</div>

<div class="chat-window chat-window--soporte" *ngIf="isOpen" [class.minimized]="isMinimized" #chatWidget>
    <div #resizer class="chat-resizer chat-resizer--soporte"></div>

    <div class="chat-header chat-header--soporte">
        <button class="collapse-btn" type="button" [attr.aria-label]="isMinimized ? 'Restaurar' : 'Minimizar'" (click)="toggleMinimize(); $event.stopPropagation()">{{ isMinimized ? '▲' : '▼' }}</button>
        <div class="chat-title">{{ config.headerTitle }}</div>
        <button class="close-btn" (click)="close(); $event.stopPropagation()" ngbTooltip="Cerrar chat" aria-label="Cerrar">✕</button>
    </div>

    <div class="chat-body" [class.empty]="messages.length === 0">
        <ng-container *ngIf="messages.length === 0; else list">
            <img src="assets/img/chat-empty.svg" alt="Sin mensajes"/>
            <p>Todavía no hay ningún mensaje</p>
        </ng-container>

        <ng-template #list>
            <div class="messages-scroll">
                <ng-container *ngFor="let msg of messages; let i = index">
                    <div *ngIf="shouldShowDateSeparator(i)" class="date-separator">
                        <span>{{ msg.date }}</span>
                    </div>

                    <div class="message" [ngClass]="{
                'from-soporte': msg.senderType === 'SOPORTE',
                'from-pdv': msg.senderType === 'PDV'
              }">
                        <div class="bubble">
                            <div class="bubble-header">
                                <span class="sender" [attr.data-type]="msg.senderType">{{ msg.senderName }}</span>
                                <i-feather name="trash" class="delete" (click)="requestDeleteMessage(msg)" *ngIf="showDeleteMessage(msg)"></i-feather>
                            </div>

                            <div class="text font a-center s-12" *ngIf="msg.file_status == 'pending'">
                                <img ngSrc="./assets/img/loader.svg" width="60" alt="" height="60">
                            </div>

                            <div class="text font s-12" *ngIf="msg.file_status != 'pending' && msg.file_url && msg.file_is_image" style="margin-bottom: 5px;">
                                <a [href]="msg.file_url" target="_blank" class="chat-img" [style.background-image]="'url(' + msg.file_url + ')'"></a>
                            </div>

                            <div class="text font s-12" *ngIf="msg.file_status != 'pending' && msg.file_url && !msg.file_is_image">
                                <a class="file-link" [href]="msg.file_url" download>
                                    <i-feather name="file"></i-feather>
                                    <span>{{ msg.file_name }}</span>
                                </a>
                            </div>

                            <div class="text font s-12" *ngIf="msg.text && msg.text != ''">{{ msg.text }}</div>

                            <span class="time">{{ msg.time }}</span>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-template>
    </div>

    <div class="chat-widget-file" *ngIf="selectedFile">
        <div class="chat-widget-file--tag chat-widget-file--tag-soporte">
            <i-feather [name]="fileIsImage() ? 'image' : 'file'"></i-feather>
            <span>{{ selectedFile.name }}</span>
            <i-feather name="x-circle" class="chat-widget-file--delete" (click)="removeFile()"></i-feather>
        </div>
    </div>

    <div class="chat-footer">
        <input type="text" placeholder="Escribe aquí tu mensaje" [(ngModel)]="newMessage" (keyup.enter)="sendMessage()"/>
        <button class="attach-btn" type="button" aria-label="Adjuntar" (click)="openFileSelector()">
            <img src="assets/img/clip.svg" alt="Adjuntar"/>
        </button>
        <button class="send-btn send-btn--soporte" type="button" aria-label="Enviar" (click)="sendMessage()">
            <img src="assets/img/chat-send.svg" alt="Enviar"/>
        </button>
    </div>
</div>
